import {useMemo, useState} from 'react';

import {
  BatchInvitationProgressDetailsResponse,
  BatchInvitationProgressItem,
  BatchInvitationProgressListResponse,
} from '../types/screeningExternalApplicantsTypes';

import {useApiRead} from '../../../../hooks/useApiRead';
import {GetRoutes} from '../../../../lib/api/GET/GetRoutes';

interface Props {
  companyId: string;
}

export const useBatchInvitationsProgress = ({companyId}: Props) => {
  const [selectedBatchId, setSelectedBatchId] = useState<string | null>(null);
  const [isDetailsOpen, setIsDetailsOpen] = useState<boolean>(false);

  const listPath = GetRoutes.screeningBatchInvitations(companyId);
  const {
    data: listResponse,
    isLoading: isListLoading,
    refetch: refetchBatchInvitations,
  } = useApiRead<BatchInvitationProgressListResponse>({
    path: listPath,
    options: {
      enabled: !!companyId,
    },
  });

  const detailsPath = selectedBatchId ? GetRoutes.screeningBatchInvitationDetails(companyId, selectedBatchId) : '';
  const {
    data: detailsResponse,
    isLoading: isDetailsLoading,
    error: detailsError,
  } = useApiRead<BatchInvitationProgressDetailsResponse>({
    path: detailsPath,
    options: {
      enabled: !!companyId && !!selectedBatchId && isDetailsOpen,
    },
  });

  const batchInvitations = useMemo<BatchInvitationProgressItem[]>(() => {
    return listResponse?.data || [];
  }, [listResponse?.data]);

  const openDetails = (batchId: string) => {
    setSelectedBatchId(batchId);
    setIsDetailsOpen(true);
  };

  const closeDetails = () => {
    setIsDetailsOpen(false);
  };

  return {
    batchInvitations,
    isListLoading,
    refetchBatchInvitations,
    selectedBatchId,
    isDetailsOpen,
    openDetails,
    closeDetails,
    detailsResponse,
    isDetailsLoading,
    detailsError,
  };
};
